import { FC, ReactNode} from "react";
import classes from './tutorAccrual.module.scss'
import { OpenContainer } from "../../../features/openContainer";
import { AddAccrualTutor } from "../../../features/addAccrualTutor";
import { TutorDownloadReceipts } from "../../../features/tutorDownloadReceipts";
import { useAppSelector } from "../../../app/store/store";
import { FEATURES, hasFeature } from "../../../entities/my";

interface IProps {
    tutorId: number;
    titleIcon?: ReactNode;
}

export const TutorAccrual: FC<IProps> = ({tutorId, titleIcon}) => {
    const {my} = useAppSelector(state => state.myReducer)
    const canCreatePayout = hasFeature(my, FEATURES.TUTORS.PAYOUTS_CREATE, tutorId)
    const canReadReceipts = hasFeature(my, FEATURES.TUTORS.RECEIPTS_READ, tutorId)

    if(!canCreatePayout && !canReadReceipts){
        return null
    }

    return (
        <section className={classes.container}>
            <OpenContainer title="Выплаты" icon={titleIcon} allowOverflow>
                <section className={classes.content}>
                    {canCreatePayout && <section className={classes.card}>
                        <AddAccrualTutor
                            tutorId={tutorId}
                        />
                    </section>}
                    {canReadReceipts && <section className={classes.card}>
                        <TutorDownloadReceipts
                            tutorId={tutorId}
                        />
                    </section>}
                </section>
            </OpenContainer>
        </section>
    )
}
